import { Box, Stack } from "@mui/material";
import React, { FC } from "react";
import Search from "./search";
import { Button } from "gatsby-theme-material-ui";
import HomeIcon from "@mui/icons-material/Home";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors-twentyfive-dark";
import { flattenHierarchy, pitNavData } from "@src/helpers/taxonomy";
import { randomIntFromInterval } from "@src/utils";
import CasinoIcon from "@mui/icons-material/Casino";
import { useWebsiteStore } from "@src/hooks/useWebsiteStore";

const commonButtonStyles = {
  height: "54px",
  border: `solid 1px ${Colors.PrimaryContrast}14`,
  borderRadius: "15px",
  whiteSpace: "nowrap",
  flexShrink: 0,
};

const flatData = flattenHierarchy(pitNavData);

const Toolbar: FC = () => {
  const setMobileExploring = useWebsiteStore(
    (state) => state.actions.setMobileExploring,
  );

  const shuffle = () => {
    const randomIndex = randomIntFromInterval(0, flatData.length - 1);
    const categoryId = flatData[randomIndex].categoryId;

    if (categoryId) {
      if (typeof window !== undefined) {
        window.location.hash = categoryId;
      }
    }
  };

  const goHome = () => {
    setMobileExploring(false);
    window.location.hash = "";
  };

  return (
    <Stack
      sx={{
        // border: 'solid 1px #FFFF00',
        height: "64px",
        width: {
          xs: "calc(100% - 32px)",
          md: "950px",
          lg: "1080px",
        },
        marginX: "auto",
        flexDirection: "row",
        gap: "12px",
        marginBottom: {
          xs: "12px",
          md: "0px",
        },
      }}
    >
      <Button
        sx={{
          ...commonButtonStyles,
          minWidth: "54px",
        }}
        onClick={goHome}
        data-testid="pit-toolbar-home"
      >
        <HomeIcon />
      </Button>

      <Search shuffle={shuffle} />

      <Button
        sx={{
          ...commonButtonStyles,
          minWidth: "54px",
        }}
        onClick={shuffle}
        data-testid="pit-toolbar-shuffle"
      >
        <Box
          component="span"
          sx={{
            display: {
              xs: "none",
              md: "block",
            },
          }}
        >
          Discover a new category&nbsp;
        </Box>
        <CasinoIcon />
      </Button>
    </Stack>
  );
};

export default Toolbar;
